import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import QuestionsForm from "./QuestionsForm";

export default function QuestionsPage() {
    const location = useLocation();
    const navigate = useNavigate();

    if(!location.state || !location.state.name) {
        return <Navigate to="/" replace={true} />;
    }

    const onSubmit = recommendations => {
        if(recommendations){
            navigate('/recommendations', {
                state: {
                    recommendations,
                    name: location.state.name                    
                }
            });
        }
    };

    return (
        <QuestionsForm name={location.state.name} onSubmit={onSubmit} />
    );
}
